module.exports = __webpack_public_path__ + "img/sprite-16.6e55c42b.png";